export interface IPracticeMcoProduct {
  mco_name: string;
  lob: string;
  members: number;
}

export interface IPracticeMcoProductResult {
  count: number;
  next: string | null;
  previous: string | null;
  results: IPracticeMcoProduct[];
}

export class PracticeMcoProduct {
  mcoName: string;
  lob: string;
  members: number;

  constructor(product: IPracticeMcoProduct) {
    this.mcoName = product.mco_name;
    this.lob = product.lob;
    this.members = product.members;
  }

  static fromObject(product: IPracticeMcoProduct): PracticeMcoProduct {
    return new PracticeMcoProduct(product);
  }

  static fromObjectArray(products: IPracticeMcoProduct[]): PracticeMcoProduct[] {
    return products.map(product => new PracticeMcoProduct(product));
  }
}

export class PracticeMcoProductResult {
  count: number;
  next: string | null;
  previous: string | null;
  results: PracticeMcoProduct[];

  constructor(result?: IPracticeMcoProductResult) {
    this.count = result?.count ?? 0;
    this.next = result?.next ?? null;
    this.previous = result?.previous ?? null;
    this.results = result ? PracticeMcoProduct.fromObjectArray(result.results) : [];
  }

  static fromObject(result: IPracticeMcoProductResult): PracticeMcoProductResult {
    return new PracticeMcoProductResult(result);
  }
}
